var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamilyPair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97,
    height: 35,
    viewBox: "0 0 97 35",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "familyPair-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 35,
    transform: "translate(-13 1.875)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "familyPair",
    transform: "translate(13 -1.875)",
    clipPath: "url(#familyPair-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.445,34.875c-3.059-7.4-11.894-8.02-15.723-9.862A14.5,14.5,0,0,1,9.472,11.645c0-5.259,3.7-9.519,8.251-9.519s8.251,4.264,8.251,9.519a14.5,14.5,0,0,1-8.251,13.368C13.889,26.855,5.059,27.48,2,34.875",
    transform: "translate(1 1)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.445,34.875c-3.058-7.4-11.894-8.02-15.722-9.862a14.494,14.494,0,0,1-8.251-13.368c0-5.259,3.7-9.519,8.251-9.519s8.251,4.264,8.251,9.519a14.5,14.5,0,0,1-8.251,13.368C99.889,26.855,91.059,27.48,88,34.875",
    transform: "translate(-52.359 1)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyPair);
export default __webpack_public_path__ + "static/media/familyPair.3c37fc5b5054b59e6db2147d396aa760.svg";
export { ForwardRef as ReactComponent };